import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export const Template = ({ image, _title, _subTitle, _text, _details }) =>
    html`<ux-iws-contact-card image="${image}">
        ${_title ? html`<div slot="title">${unsafeHTML(_title)}</div>` : null}
        ${_subTitle
            ? html`<div slot="sub-title">${unsafeHTML(_subTitle)}</div>`
            : null}
        ${_text ? html`<div slot="text">${unsafeHTML(_text)}</div>` : null}
        ${unsafeHTML(_details)}
    </ux-iws-contact-card>`;

const dummyProps = {
    image: "",
    _title: "This is the title",
    _subTitle: "",
    _text: "",
    _details: `<a slot="details" href="tel:123456789">Tel: 123456789</a>
                 <a slot="details" href="#">Email: thomas.mischer</a>`,
};

export const MultipleTemplate = () => html`
    <div>${Template(dummyProps)} ${Template(dummyProps)}</div>
`;
